<template>
  <div :class="($route.path === '/checkout')?
        'col-12 p-0':
        'col p-0'">
    <button
      id="razor-pay-web-button"
      class="btn btn-primary btn-type-primary blue-btn mt-4 mx-auto"
      @click.prevent="razorPayOrder"
						v-if="$route.path !== '/vendorPlan'"
						data-test="razorPayWebBtn"
    >
      Pay Using Razor Pay
    </button>
				<button
					id="razor-pay-subscription-web-button"
					class="btn btn-block btn-outline-primary"
					v-else
					:style="(buttonActive === true)?
											'background-color: green;color: white;':
											'color: green;'"
					@click.prevent="razorPayOrder"
					data-test="razorPayWebPayBtn"
				>
					Pay
				</button>
  </div>
</template>

<script>
import tenantSpecificNames from '@/commonJs/tenantSpecificNames'
import { mapGetters, mapActions } from 'vuex'
import { store } from '../../../../store/store'
import { orderApi } from '../../../../services/ApiServices/orderApi'
// import * as e from 'bootstrap-vue';

export default {
	name: 'razor-pay-web-integration',
	computed: {
		...mapGetters('user', ['getUserData', 'getOrderData', 'getGiftCardDetails']),
		...mapGetters('siteData', ['getPaymentId']),
		...mapGetters('vendor', ['getSubscriptionOrderData'])
	},
	mounted () {
		const razorPayScript = document.createElement('script')
		razorPayScript.setAttribute('src', 'https://checkout.razorpay.com/v1/checkout.js')
		document.head.appendChild(razorPayScript)
	},
	data () {
		return {
			razorPayOrderNumber: '',
			buttonActive: false
		}
	},
	watch: {
		getPaymentId (val) {
			orderApi.verifyRazorPayPayment()
				.then(() => {
					if (this.getGiftCardDetails && this.getGiftCardDetails.gift_cards) {
						this.$toasted.show('Gift Card created successfully')
						this.$router.push('/')
						this.clearGiftData()
					} else if (this.getSubscriptionOrderData && this.getSubscriptionOrderData.order_number) {
						this.$toasted.show('Subscription Payment Completed Successfully')
						this.$router.push('/pages/vendordashboard')
						this.setSubscriptionOrderData({})
					} else {
						this.$router.push({
							path: '/order-success',
							query: {
								order_number: this.getOrderData.order_number,
								payment_mode: 'card'
							}
						})
					}
				})
		}
	},
	methods: {
		...mapActions('user', [
			'clearGiftData'
		]),
		...mapActions('vendor', [
			'setSubscriptionOrderData'
		]),
		pay () {
			const options = {
				key: tenantSpecificNames.razorPayKey, // 'rzp_live_Im4Cag6lCnir7B',
				amount: this.getOrderData.total_amount * 100,
				// amount: 100,
				name: 'Women Power',
				description: 'Purchase Payment',
				order_id: this.razorPayOrderNumber,
				image: 'https://tst-ecommerce.s3.amazonaws.com/test-client-id/PROFILE-PICTURES/825074912-a2d4cc9b-f789-4928-a72b-9a787a739d96.png',
				redirect: false,
				handler (response) {
					// alert(response);

					this.paymentId = response.razorpay_payment_id
					//

					store.dispatch('siteData/setPaymentIdData', response)
				},
				prefill: {
					name: '',
					email: '',
					contact: ''
				},
				notes: {
					address: 'Hello World'
				},
				theme: {
					color: '#ba9652'
				}
			}
			const rzp1 = new Razorpay(options)
			rzp1.open()
			// e.preventDefault();
		},
		razorPayOrder () {
			orderApi.orderCharge()
				.then((res) => {
					this.razorPayOrderNumber = res.data.response
					setTimeout(() => {
						this.buttonActive = true
						this.pay()
					}, 500)
				})
			// this.pay();
			// orderApi.orderCharge('card').then((res) => {
			//   store.dispatch('user/setOrderData', res.data);
			//   setTimeout(() => {
			//     this.pay();
			//   }, 500);
			// });
		}
	}
}
</script>
